module.exports = __webpack_public_path__ + "static/media/stamp.9e0f2bcb.svg";